module.exports = __webpack_public_path__ + "img/62-l.e8609a6f.png";